export default __webpack_public_path__ + "static/media/404error.be68e5b9.png";